import { render, staticRenderFns } from "./TourCategories.vue?vue&type=template&id=38205e9e&scoped=true&"
import script from "./TourCategories.vue?vue&type=script&lang=js&"
export * from "./TourCategories.vue?vue&type=script&lang=js&"
import style0 from "./TourCategories.vue?vue&type=style&index=0&id=38205e9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38205e9e",
  null
  
)

export default component.exports